export const UpdatePasswordTestIDs = {
  passwordInput: "update-password-input",
  passwordConfirmInput: "update-password-confirm-input",
  submitButton: "update-password-submit-button",
};
